import React from 'react';
import PropTypes from "prop-types";

const MainFooter = (props) => {
    return (
        <footer className="page__footer">
            <div className={`page__footer__inner ${props.addClass}`}>
                {props.children}
            </div>
        </footer>
    );
};

export default MainFooter;

MainFooter.defaultProps = {
    addClass: '',
};

MainFooter.propTypes = {
    addClass: PropTypes.string,
    children: PropTypes.node,
};




// WEBPACK FOOTER //
// ./sources/js/components/layout/MainFooter.js